import React from "react";

const Socials = () => {
  return (
    <div className="hidden lg:flex fixed top-1/2 right-0 flex-col shadow-2xl transform -translate-y-1/2 ">
      <a
        href="https://www.facebook.com/profile.php?id=1839408720"
        target="_blank"
        rel="noopener noreferrer"
        className="flex justify-center items-center w-12 h-12 bg-gradient-to-r hover:from-indigo-400 hover:to-blue-400 from-white border-transparent to-white hover:border-blue-400 hover:text-white md:text-lg border border-gray-200 shadow-lg"
      >
        <i className="fab fa-facebook-f" aria-hidden="true"></i>
      </a>
      <a
        href="https://twitter.com/Gambiiiit"
        target="_blank"
        rel="noopener noreferrer"
        className="flex justify-center items-center w-12 h-12 p- m-0 bg-gradient-to-r hover:from-indigo-400 hover:to-blue-400 from-white border-transparent to-white hover:border-blue-400 hover:text-white md:text-lg border border-gray-200 shadow-lg"
      >
        <i className="fab fa-twitter" aria-hidden="true"></i>
      </a>
      <a
        href="https://github.com/Gambit42"
        target="_blank"
        rel="noopener noreferrer"
        className="flex justify-center items-center w-12 h-12 p- m-0 bg-gradient-to-r hover:from-indigo-400 hover:to-blue-400 from-white border-transparent to-white hover:border-blue-400 hover:text-white md:text-lg border border-gray-200 shadow-lg"
      >
        <i className="fab fa-github" aria-hidden="true"></i>
      </a>
      <a
        href="https://www.linkedin.com/in/prins-ocampo-829956234/"
        target="_blank"
        rel="noopener noreferrer"
        className="flex justify-center items-center w-12 h-12 p- m-0 bg-gradient-to-r hover:from-indigo-400 hover:to-blue-400 from-white border-transparent to-white hover:border-blue-400 hover:text-white md:text-lg border border-gray-200 shadow-lg"
      >
        <i className="fab fa-linkedin" aria-hidden="true"></i>
      </a>
    </div>
  );
};

export default Socials;
